import { render } from "./UserAddData.vue?vue&type=template&id=5d617b6d"
import script from "./UserAddData.vue?vue&type=script&lang=js"
export * from "./UserAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__